var SlickCarouselModule = (function(window,document,undefined){

	'use strict';

	/**
	 * Variables
	 */
	var settings;
	var defaults = {
		"autoplay": false,
		"autoplaySpeed": 2,
		"speed": 400,
		"dots": true,
		"arrows": true,
		"items_xs": 1,
		"items_s": 2,
		"items_m": 3,
		"items_l": 4,
		"items_xl": 5,
		"isCanvasType": false,
		"afterInit": undefined
	};

	/**
	 * Private Methods
	 * @private
	 */
	var generate = function ( el, options ) {
		settings = _.extend({}, defaults, options || {} );
		el.on('init.showCarousel',function(event,slick){
			$(this).parents(".loading").removeClass('loading');
			if(typeof settings.afterInit === "function")
			{
				settings.afterInit.apply();
			}
			handleArrowsHover(slick);
		});

		el.on('afterChange.lazyLoad',function(event,slick){
			Imgness.refresh();
			goToFirstSlide(slick);
		});

		var slickOpts = {
			infinite: false,
			speed: parseInt(settings.speed,10),
			dots: settings.dots,
			dotsClass: "slick-dots cf",
			arrows: settings.arrows,
			autoplay: settings.autoplay,
			autoplaySpeed: parseInt(settings.autoplaySpeed,10) * 1000,
			slidesToShow: 1,
			slidesToScroll: 1,
			touchThreshold: 100,
			cssEase: 'linear',
			prevArrow:"<button type='button' class='slick-prev'><span class='i-arrow'></span></button>",
			nextArrow:"<button type='button' class='slick-next'><span class='i-arrow'></span></button>"
		};

		if(settings.isCanvasType){
			slickOpts.responsive = [
				{
					breakpoint: 481,
					settings: {
						dots: false
					}
				}
			];
		} else {
			slickOpts.slidesToShow = parseInt(settings.items_xl,10);
			slickOpts.slidesToScroll =parseInt(settings.items_xl,10);
			slickOpts.responsive = [
				{
					breakpoint: 1106,
					settings: {
						slidesToShow: parseInt(settings.items_l,10),
						slidesToScroll: parseInt(settings.items_l,10)
					}
				},
				{
					breakpoint: 961,
					settings: {
						slidesToShow: parseInt(settings.items_m,10),
						slidesToScroll: parseInt(settings.items_m,10)
					}
				},
				{
					breakpoint: 705,
					settings: {
						slidesToShow: parseInt(settings.items_s,10),
						slidesToScroll: parseInt(settings.items_s,10)
					}
				},
				{
					breakpoint: 481,
					settings: {
						dots: false,
						slidesToShow: parseInt(settings.items_xs,10),
						slidesToScroll: parseInt(settings.items_xs,10)
					}
				}
			];
		}
		el.slick(slickOpts);
	};

	var generateSingleCustom = function($el,options){
		var defaultOptions = {
			"infinite": false,
			prevArrow:"<button type='button' class='slick-prev'><span class='i-arrow'></span></button>",
			nextArrow:"<button type='button' class='slick-next'><span class='i-arrow'></span></button>"
		};

		settings = _.extend({}, options, defaultOptions || {} );

		if(typeof settings.afterInit === "function")
		{
			$el.on('init.lazyLoad',function(event,slick){
				slick.slickGoTo(settings.currentPosition?settings.currentPosition:0,true);
				settings.afterInit.apply();
			});
		}

		if(typeof settings.afterChange === "function")
		{
			$el.on('afterChange.lazyLoad',function(event,slick){
				goToFirstSlide(slick);
				settings.afterChange.apply();
			});
		}

		$el.slick(settings);
	};

	var goToFirstSlide = function (slick) {
		if(slick.$nextArrow) {
			if (slick.$nextArrow.hasClass('slick-disabled')) {
				slick.$nextArrow.on('click.slickBack', function (e) {
					slick.slickGoTo(0, true);
					slick.$nextArrow.off('click.slickBack');
				})
			} else {
				slick.$nextArrow.off('click.slickBack');
			}
		}
	};

	var handleArrowsHover = function(slick) {
		if(slick.$nextArrow) {
			slick.$nextArrow.off('touchstart.hoverTouch blur.hoverTouch').on('touchstart.hoverTouch blur.hoverTouch', function (e) {
				$(this).toggleClass('is-touch', e.type === 'touchstart');
			});
		}

		if(slick.$prevArrow) {
			slick.$prevArrow.off('touchstart.hoverTouch').on('touchstart.hoverTouch', function (e) {
				$(this).toggleClass('is-touch', e.type === 'touchstart');
			});
		}
	};

	/**
	 * generate the sync carousel
	 * @param $sliderNav
	 * @param $sliderFor
	 */
	var generateSync = function($sliderNav,$sliderFor){
		var defaultOptions = {
			prevArrow:"<button type='button' class='slick-prev'><span class='i-arrow'></span></button>",
			nextArrow:"<button type='button' class='slick-next'><span class='i-arrow'></span></button>"
		};

		//set settings and extend with defaults
		var sliderForOptions = $.parseJSON($sliderFor.data('options'));
		var sliderNavOptions = $.parseJSON($sliderNav.data('options'));
		sliderForOptions = _.extend({}, sliderForOptions, defaultOptions || {} );
		sliderNavOptions = _.extend({}, sliderNavOptions, defaultOptions || {} );

		$sliderFor.on('afterChange.lazyLoad',function(event,slick){
			Imgness.refresh();
			goToFirstSlide(slick);
		});

		$sliderNav.on('afterChange.lazyLoad',function(event,slick){
			Imgness.refresh();
			goToFirstSlide(slick);
		});

		//star sync carousel
		$sliderFor.slick(sliderForOptions);
		$sliderNav.slick(sliderNavOptions);
	};


	/**
	 * init
	 * @public
	 * @param el
	 * @param options
	 */
	var init = function(options) {
		var $carousel = $(options.selector).not('.slick-initialized');
		$carousel.each(function(){
			var $el = $(this);
			var elOptions = $el.data('options');
			if(typeof elOptions == "string"){
				elOptions = $.parseJSON($el.data('options'));
			}
			var settings = _.extend({}, elOptions, options || {} );
			generate($el,settings);
		});
	};

	/**
	 * initSingle
	 * @public
	 * @param el
	 */
	var initSingle = function($el){
		generate($el,$.parseJSON($el.data('options')));
	};

	var initSingleCustom = function($el,opts){
		generateSingleCustom($el,opts);
	};

	/**
	 *
	 * @param options
	 */
	var initSync = function(options){
		var $carousel = $(options.selector).not('.slick-initialized');
		$carousel.each(function(){
			var $sliderNav = $(this);
			var sliderForRef = $sliderNav.data('syncSlider');
			var $sliderFor = $(".j-slickFor[data-sync-slider='"+sliderForRef+"']");
			if($sliderFor.length<=0 || $sliderFor.length>1){
				console.error('found '+ $sliderFor.length+' sliderFor sliderNav with data-sync-slider='+sliderForRef);
				return;
			}
			generateSync($sliderNav,$sliderFor);
		});
	};

	var refresh = function($carousels){
		var $carousels = ($carousels===undefined?$('.slick-initialized'):$carousels);
		$carousels.each(function(){
			var $el = $(this);
			$el.slick('unslick');
			initSingle($el);
		});
	};

	return {
		init:init,
		initSingle:initSingle,
		initSingleCustom:initSingleCustom,
		initSync:initSync,
		refresh:refresh
	}

}(window,document));
